// pack-options.js
document.addEventListener('DOMContentLoaded', function() {
  try {
    // Unique per section: we will pass section.id from Liquid when including script tag.
  } catch (e) {
    console.error(e);
  }
});

// The real initialization is injected by Liquid below (so we can pass section id + product form id)
